




export default {
  name: 'CreateTaskDecorationIcon'
}
